import { CREATE_EVENTS_START } from "../../types";

export const create_event = (payload) => ({
  type: CREATE_EVENTS_START,
  payload,
});
